import React from "react";
import moment from "moment";

import { Popover, OverlayTrigger } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagic, faExclamationTriangle, faDownload } from "@fortawesome/free-solid-svg-icons";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import styles from "./style.module.css";

export default class ScoreTile extends React.PureComponent {
  render() {
    const { score, onClick } = this.props;

    const isError = score.status === "ERROR";
    const isDownloadLoading = score.isDownloadLoading;
    const isReady = score.status === "DONE";

    const isWarning = score.warnings && score.warnings.length > 0;
    const warnings = isWarning ? score.warnings : [];

    let title =
      score.errors && score.errors.length > 0
        ? score.errors.length + " Error" + (score.errors.length > 1 ? "s" : "")
        : "";

    if (isWarning) {
      title += title === "" ? "" : ", ";
      title += warnings.length + " Warning" + (warnings.length > 1 ? "s" : "");
    }

    return (
      <div
        className={isReady ? styles.deployTile : styles.deployTileNoHover}
        onClick={onClick && isReady ? () => onClick() : () => {}}
        title={score.id}
      >
        <div className={styles.topMessage}>
          {isReady ? "Download Scored Dataset" : isError ? "Error Scoring Dataset" : "Processing"}
        </div>
        {score.errors && score.errors.length > 0 ? (
          <OverlayTrigger
            placement="top"
            trigger={["click"]}
            rootClose
            overlay={
              <Popover id="popover-positioned-top" title={title}>
                <div className={styles.wList}>
                  {score.errors.map((error, index) => (
                    <div key={index} className={styles.warnMsg}>
                      {error.message}
                    </div>
                  ))}
                  {warnings.map((warning, index) => (
                    <div key={index} className={styles.warnMsg}>
                      Warning: {warning.message}
                    </div>
                  ))}
                </div>
              </Popover>
            }
          >
            <div className={styles.warnH}>
              <div className={styles.warningIcon}>
                <FontAwesomeIcon icon={faExclamationTriangle} />
                <div className={styles.eMsg}>{"Click to see Errors"}</div>
              </div>
            </div>
          </OverlayTrigger>
        ) : isError ? (
          <div className={styles.warnH}>
            <div className={styles.warningIcon}>
              <FontAwesomeIcon icon={faExclamationTriangle} />
            </div>
            <div className={styles.warningMessage}>{"Error"}</div>
          </div>
        ) : isDownloadLoading ? (
          <div className={styles.icon}>
            <LoadingIndicator style={{ margin: "0px" }} />
          </div>
        ) : isReady ? (
          <div className={styles.icon}>
            <FontAwesomeIcon icon={faDownload} />
          </div>
        ) : (
          <div className={styles.icon}>
            <LoadingIndicator style={{ margin: "0px" }} />
          </div>
        )}
        <div className={styles.botMessage}>
          <div
            className={styles.botDate}
            title={moment.utc(score.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}
          >
            <div>Id: {score.id}</div>
            {moment.utc(score.created_date).local().fromNow()}
          </div>
          {isReady && isWarning ? (
            <OverlayTrigger
              placement="top"
              trigger={["click"]}
              rootClose
              overlay={
                <Popover id="popover-positioned-top" title={title}>
                  <div className={styles.wList}>
                    {warnings.map((warning, index) => (
                      <div key={index} className={styles.warnMsg}>
                        {warning.message}
                      </div>
                    ))}
                  </div>
                </Popover>
              }
            >
              <div onClick={(e) => e.stopPropagation()} className={styles.warnMsgLink}>
                {title}
              </div>
            </OverlayTrigger>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}
